<div class="result-table">
  <div class="result-table-title">
    <div class="result-table-title__text" translate>{{title}}</div>
    <div>
      <span class="result-table-title__count">{{limit < total ? limit : total}} of {{total}}</span>
      <span class="result-table-title__show" *ngIf="limit < total" (mousedown)="showAll()">(Show all)</span>
    </div>
  </div>
  <div class="result-table">
    <div class="result-table-headers">
      <div class="result-table-headers__cell" *ngFor="let columnDef of columnDefs" translate>{{columnDef.title}}</div>
    </div>
    <div class="result-table-row" *ngFor="let row of rowData.slice(0, limit)" (mousedown)="onRowClicked(row)">
      <div class="result-table-row__cell alignItems" [ngStyle]="{'width': '33%'}" *ngFor="let columnDef of columnDefs | slice:0:2; let i=index">
        {{getRowDisplayByMap(row, columnDef.mapFn)}}
      </div>
      <div [ngStyle]="{'width': '4%'}">
        <span *ngIf="displayTooltipValues(row).showTooltip" genTooltip
          [tooltipHtml]="displayTooltipValues(row).htmlContentIcon"
          [tooltipPosition]="'RIGHT'"
          [appendToBody]="'true'"
          [tooltipShow]="true">
          &nbsp;<img style="height: 1.3rem;" src="assets/ispm/icons/Info_Icon.png">
        </span>
      </div>
      <div class="result-table-row__cell alignItems" [ngStyle]="{'width': '30%'}" >
        {{getRowDisplayByMap(row, columnDefs[columnDefs.length-1].mapFn)}}
      </div>
    </div>
  </div>
</div>
